import Pause from '../../src/legacy/Pause.tsx';
export default Pause;
